import React from 'react';
import api from '../config/configApi';

export const logUsuarioForm = async (logData) => {
  try {
    await api.post('/api/logs/formularios', logData);
  } catch (err) {
    const errorMessage = err.response?.data?.msg || err.message || 'Erro desconhecido ao adicionar Log de Usuario no Formulario.';
    logError({
      email: logData.email,
      log_erro: `Erro ao logar acesso a formulário: ${errorMessage}`,
      formulario: logData.formulario,
    })
  }
}

export const logError = async (errorData) => {
  try {
    await api.post('/api/logs/erros', errorData);
  } catch (logError) {
    console.warn('Falha ao salvar o erro: ', logError);
  }
}

export const logClickView = async (veiculoId) => {
  try {
    await api.post(`/api/visualizacoes/${veiculoId}`);
  } catch(err) {
    console.warn('Falha ao salvar a visualização: ', err);
  }
}